import {Box, Button, Grid, Paper, Skeleton, TextField, Typography} from "@mui/material";
import axios from "axios";
import * as React from "react";
import {Config} from "../../config/config";
import {PopupMessage} from "../../utils/message";
import {Helpers} from "../../utils/helpers";
import CircularProgress, {CircularProgressProps} from '@mui/material/CircularProgress';


const style = {
    // height: '100px',
    padding: '10px',
    width: '100%',
    backgroundColor: "black",
} as React.CSSProperties

export class InactiveUser extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            loading: false,
            filter: {
                playTime: 0,
                daysSinceLastLogin: 10,
            },
            panel: {
                amount: 0,
                deleteUser: {
                    proceeding: false,
                    progress: {
                        total: 0,
                        amount: 0,
                        failed: 0,
                    },
                    timer: null,
                    limit: 0,
                    failedList: [],
                    skipWebUser: false,
                }
            }
        }
    }

    componentDidMount(): void {
        this.getInactiveAmount();
    }

    componentWillUnmount(): void {
        this.stopDeleteTimer();
    }

    async getInactiveAmount() {
        const url = `${Config.getInstance.apiUrl}/api/inactive-user/amount`;

        const {filter} = this.state;

        const params = {
            playTime: filter.playTime,
            daysSinceLastLogin: filter.daysSinceLastLogin,
        };

        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        this.setState({loading: true});

        const response = await axios.get(url, {params, headers});

        const data = response.data;

        const success = data.success;
        if (success) {
            const amount = data.amount;
            const {panel} = this.state;

            panel.amount = amount;

            this.setState({panel, loading: false});
        } else {
            PopupMessage.error("Failed to get inactive amount")
        }
    }

    onChangeFilter(e, key) {
        const {filter} = this.state;
        filter[key] = e.target.value;
        this.setState({filter});
    }

    async deleteInactiveUser(skipWebUser = false) {
        const {panel} = this.state;
        const {deleteUser} = panel;
        deleteUser.proceeding = true;
        this.setState(deleteUser);

        const url = `${Config.getInstance.apiUrl}/api/inactive-user/delete`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        const body = {
            playTime: this.state.filter.playTime,
            daysSinceLastLogin: this.state.filter.daysSinceLastLogin,
            limit: deleteUser.limit,
            skipWebUser,
        };
        this.startDeleteTimer();

        const reponse = await axios.post(url, body, {headers});

        this.stopDeleteTimer();

        const data = reponse.data;

        const success = data.success;

        deleteUser.proceeding = false;
        this.setState(deleteUser);
        if (success) {
            PopupMessage.success("Successfully deleted inactive user");

            const failedList = data.failedList;
            deleteUser.failedList = failedList;
            this.setState(deleteUser);
            this.getInactiveAmount();

            if(failedList.length > 0) {
                // Ask if user wants to delete account without calling web
                if(confirm("Delete Account from Web failed. Do you want to delete account without calling web?")){
                    this.deleteInactiveUser(true);
                }
            }
        } else {
            PopupMessage.error("Failed to delete inactive user");
        }
    }

    renderFilter() {
        const {filter} = this.state;

        return <Paper className="root" elevation={0} style={style}>
            <Typography variant="h4" style={{padding: '20px'}}>
                Filter
            </Typography>
            <Grid container sm={12} rowSpacing={2} spacing={2}>
                <Grid item container sm={12}>
                    <Grid item sm={3}>
                        <TextField
                            label="Play Time"
                            value={filter.playTime}
                            onChange={(e) => this.onChangeFilter(e, 'playTime')}
                        />
                    </Grid>

                </Grid>
                <Grid item container sm={12}>
                    <Grid item sm={3}>
                        <TextField
                            label="Days Since Last Login"
                            value={filter.daysSinceLastLogin}
                            onChange={(e) => this.onChangeFilter(e, 'daysSinceLastLogin')}
                        />
                    </Grid>
                </Grid>

                <Grid item container sm={12} justifyContent={"flex-end"}>
                    <Grid item sm={1}>
                        <Button
                            variant="contained"
                            onClick={() => this.getInactiveAmount()}
                        >
                            Request
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Paper>
    }

    async getDeleteProgress() {
        const url = `${Config.getInstance.apiUrl}/api/inactive-user/delete-progress`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        }
        const response = await axios.get(url, {headers});

        const data = response.data;

        const success = data.success;

        if (success) {
            const {panel} = this.state;
            const {deleteUser} = panel;

            deleteUser.progress = data.progress;

            this.setState({panel});
        } else {
            PopupMessage.error("Failed to get delete progress");
        }
    }

    startDeleteTimer() {
        const {panel} = this.state;
        const {deleteUser} = panel;

        deleteUser.timer = setInterval(() => {
            this.getDeleteProgress();
        }, 1000);

        this.setState({panel});
    }

    stopDeleteTimer() {
        const {panel} = this.state;
        const {deleteUser} = panel;

        clearInterval(deleteUser.timer);
        deleteUser.timer = null;

        this.setState({panel});
    }

    renderDeletePanel() {
        const {panel} = this.state;
        const {deleteUser} = panel;

        let value = 0;

        if (deleteUser.proceeding) {
            value = deleteUser.progress.total > 0 ? ((deleteUser.progress.amount + deleteUser.progress.failed) / deleteUser.progress.total) * 100 : 0;
        }

        return <Paper className="stats-root" elevation={0}>
            <div style={{float: "left", padding: "15px 22px 15px 22px", width: "100%", textAlign: "center"}}>
                <div>
                    <Typography variant="h6" style={{textAlign: "center"}}>
                        Delete Inactive User
                    </Typography>

                    {
                        deleteUser.proceeding ?
                            <Box sx={{position: 'relative', display: 'inline-flex'}}>
                                <CircularProgress variant="determinate"  {...{value}} />
                                {/* <Box
                                    sx={{
                                        top: 0,
                                        left: 0,
                                        bottom: 0,
                                        right: 0,
                                        position: 'absolute',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <Typography
                                        variant="caption"
                                        component="div"
                                        color="text.secondary"
                                    >{`${Math.round(value)}%`}</Typography>
                                </Box> */}
                            </Box>
                            : <Grid container sm={12} spacing={2} style={{marginTop: '2%'}}>
                                <Grid item sm={5}>
                                    <TextField
                                        label="Limit"
                                        value={deleteUser.limit}
                                        onChange={(e) => {
                                            const {panel} = this.state;
                                            const {deleteUser} = panel;
                                            deleteUser.limit = e.target.value;
                                            this.setState({panel});
                                        }}
                                    />
                                </Grid>
                                <Grid item sm={5}>
                                    <Button
                                        variant="contained"
                                        onClick={() => this.deleteInactiveUser()}
                                    >
                                        Proceed
                                    </Button>

                                    <Typography
                                        visibility={deleteUser.failedList.length > 0 ? "visible" : "hidden"}
                                    ><span style={{color:"red"}}>Failed: {deleteUser.failedList.length}</span></Typography>
                                </Grid>
                            </Grid>


                    }

                </div>
            </div>
        </Paper>
    }

    renderPanel() {
        const {panel} = this.state;

        return <Paper className="root" elevation={0} style={style}>
            <Typography variant="h4" style={{padding: '20px'}}>
                Panel
            </Typography>
            <Grid container sm={12} rowSpacing={2} spacing={2}>
                <Grid item container sm={12} spacing={2}>
                    <Grid item sm={3}>
                        <Paper className="stats-root" elevation={0}>
                            <div style={{float: "left", padding: "15px 22px 15px 22px", width: "100%"}}>
                                <div>
                                    <Typography variant="h6" style={{textAlign: "center"}}>
                                        Total Inactive User
                                    </Typography>

                                    <Typography variant="h3" style={{textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center"}}>
                                        {!this.state.loading ? Helpers.formatNumber(panel.amount) : <Skeleton width={150} />}
                                    </Typography>
                                </div>
                            </div>
                        </Paper>
                    </Grid>

                    <Grid item sm={3}>
                        {this.renderDeletePanel()}
                    </Grid>
                </Grid>
            </Grid>
        </Paper>
    }

    render() {

        return <div className="contentPadding" style={{width: "100%"}}>
            {/* <Paper className="root" elevation={0}> */}
            <Typography variant="h2" style={{marginBottom: '50px'}}>
                Inactive User
            </Typography>
            <Grid container sm={12} rowSpacing={2} spacing={2}>
                <Grid item container sm={12}>
                    {this.renderFilter()}
                </Grid>
                <Grid item container sm={12}>
                    {this.renderPanel()}
                </Grid>
            </Grid>
            {/* </Paper> */}
        </div>
    }
}